export const REDIRECT_TO_ALL_MESSAGES = 'REDIRECT_TO_ALL_MESSAGES'
